const colors = {
    contrastThreshold: 7,
    // Singleton colors
    white: '#FFFFFF',
    black: '#000000',
    lightText: '#FFFFFF',
    darkText: '#000000',
    trustedShops: {
      'main': '#ffdd11'
    },
    // Primary colors

    bmwLightBlue: {
        50: '#FEFEFF',
        100: '#E4F4FF',
        200: '#B1DEFF',
        300: '#7EC8FF',
        400: '#4BB3FF',
        500: '#189DFF',
        600: '#0083E4',
        700: '#0066B1',
        800: '#00497E',
        900: '#002B4B',
        1000: '#001f36',
        1100: '#001626',
        1200: '#000f1a',
        1300: '#00090f',
        1400: '#00050a',
        1500: '#000306',
        'main': '#247bb5'
    },

    bmwBlue: {
        50: '#FCFDFF',
        100: '#E3F1FE',
        200: '#B1D8FD',
        300: '#7FC0FC',
        400: '#4DA7FB',
        500: '#1C8EF9',
        600: '#0575DD',
        700: '#045AAB',
        800: '#034079',
        900: '#022647',
        1000: '#011b34',
        1100: '#011226',
        1200: '#000c19',
        1300: '#00070f',
        1400: '#00040a',
        1500: '#000206',
        'main': '#034079'
    },

    bmwRed: {
        50: '#FCE7E6',
        100: '#FAD2CF',
        200: '#F4A6A2',
        300: '#EF7A74',
        400: '#EA4E46',
        500: '#E3241A',
        600: '#B51D15',
        700: '#871510',
        800: '#5A0E0A',
        900: '#2C0705',
        1000: '#1f0504',
        1100: '#160403',
        1200: '#0f0302',
        1300: '#0a0201',
        1400: '#050101',
        1500: '#030000',
        'main': '#ba0f18'
    },
    "baumGray": {
        "main": '#2d2d2d'
    },
    rose: {
      50: '#fff1f2',
      100: '#ffe4e6',
      200: '#fecdd3',
      300: '#fda4af',
      400: '#fb7185',
      500: '#f43f5e',
      600: '#e11d48',
      700: '#be123c',
      800: '#9f1239',
      900: '#881337',
      1000: '#6f0f2d',
      1100: '#590c23',
      1200: '#420919',
      1300: '#2f0611',
      1400: '#1f040b',
      1500: '#130207',
    },
    pink: {
      50: '#fdf2f8',
      100: '#fce7f3',
      200: '#fbcfe8',
      300: '#f9a8d4',
      400: '#f472b6',
      500: '#ec4899',
      600: '#db2777',
      700: '#be185d',
      800: '#9d174d',
      900: '#831843',
      1000: '#6a1436',
      1100: '#54102b',
      1200: '#3f0c20',
      1300: '#2d0817',
      1400: '#1f050f',
      1500: '#13030a',
    },
    violet: {
      50: '#f5f3ff',
      100: '#ede9fe',
      200: '#ddd6fe',
      300: '#c4b5fd',
      400: '#a78bfa',
      500: '#8b5cf6',
      600: '#7c3aed',
      700: '#6d28d9',
      800: '#5b21b6',
      900: '#4c1d95',
      1000: '#3d1778',
      1100: '#2f125d',
      1200: '#220d43',
      1300: '#18092f',
      1400: '#100620',
      1500: '#090312',
    },
    blue: {
      50: '#eff6ff',
      100: '#dbeafe',
      200: '#bfdbfe',
      300: '#93c5fd',
      400: '#60a5fa',
      500: '#3b82f6',
      600: '#2563eb',
      700: '#1d4ed8',
      800: '#1e40af',
      900: '#1e3a8a',
      1000: '#182e6f',
      1100: '#122456',
      1200: '#0d193e',
      1300: '#09112c',
      1400: '#060b1d',
      1500: '#030610',
    },
    lightBlue: {
      50: '#f0f9ff',
      100: '#e0f2fe',
      200: '#bae6fd',
      300: '#7dd3fc',
      400: '#38bdf8',
      500: '#0ea5e9',
      600: '#0284c7',
      700: '#0369a1',
      800: '#075985',
      900: '#0c4a6e',
      1000: '#06425d',
      1100: '#043246',
      1200: '#03212f',
      1000: '#06425d',
      1100: '#043246',
      1200: '#03212f',
      1300: '#021724',
      1400: '#011018',
      1500: '#00090e',
    },
    darkBlue: {
      50: '#dbf4ff',
      100: '#addbff',
      200: '#7cc2ff',
      300: '#4aa9ff',
      400: '#1a91ff',
      500: '#0077e6',
      600: '#005db4',
      700: '#004282',
      800: '#002851',
      900: '#000e21',
      1000: '#000a18',
      1100: '#000711',
      1200: '#00050c',
      1300: '#000307',
      1400: '#000204',
      1500: '#000102',
    },
    cyan: {
      50: '#ecfeff',
      100: '#cffafe',
      200: '#a5f3fc',
      300: '#67e8f9',
      400: '#22d3ee',
      500: '#06b6d4',
      600: '#0891b2',
      700: '#0e7490',
      800: '#155e75',
      900: '#164e63',
      1000: '#113e4f',
      1100: '#0d303d',
      1200: '#09222b',
      1300: '#06171e',
      1400: '#040f14',
      1500: '#02090c',
    },
    green: {
      50: '#f0fdf4',
      100: '#dcfce7',
      200: '#bbf7d0',
      300: '#86efac',
      400: '#4ade80',
      500: '#22c55e',
      600: '#16a34a',
      700: '#15803d',
      800: '#166534',
      900: '#14532d',
      1000: '#104224',
      1100: '#0c331c',
      1200: '#092613',
      1300: '#061b0d',
      1400: '#041208',
      1500: '#020a04',
    },
    lime: {
      50: '#f7fee7',
      100: '#ecfccb',
      200: '#d9f99d',
      300: '#bef264',
      400: '#a3e635',
      500: '#84cc16',
      600: '#65a30d',
      700: '#4d7c0f',
      800: '#3f6212',
      900: '#365314',
      1000: '#2b4210',
      1100: '#21330c',
      1200: '#172507',
      1300: '#101a05',
      1400: '#0a1103',
      1500: '#050a01',
    },
    yellow: {
      50: '#fefce8',
      100: '#fef9c3',
      200: '#fef08a',
      300: '#fde047',
      400: '#facc15',
      500: '#eab308',
      600: '#ca8a04',
      700: '#a16207',
      800: '#854d0e',
      900: '#713f12',
      1000: '#5b3210',
      1100: '#47270c',
      1200: '#331c08',
      1300: '#241405',
      1400: '#170d03',
      1500: '#0d0701',
    },
    orange: {
      50: '#fff7ed',
      100: '#ffedd5',
      200: '#fed7aa',
      300: '#fdba74',
      400: '#fb923c',
      500: '#f97316',
      600: '#ea580c',
      700: '#c2410c',
      800: '#9a3412',
      900: '#7c2d12',
      1000:'#662510',
      1100:'#521d0d',
      1200:'#3f160a',
      1300:'#2d1007',
      1400:'#1e0a04',
      1500:'#120602',
    },
    red: {
      50: '#fef2f2',
      100: '#fee2e2',
      200: '#fecaca',
      300: '#fca5a5',
      400: '#f87171',
      500: '#ef4444',
      600: '#dc2626',
      700: '#b91c1c',
      800: '#991b1b',
      900: '#7f1d1d',
      1000: '#661717',
      1100: '#511212',
      1200: '#3c0d0d',
      1300: '#2a0909',
      1400: '#1c0505',
      1500: '#110303',
    },
    warmGray: {
      50: '#fafaf9',
      100: '#f5f5f4',
      200: '#e7e5e4',
      300: '#d6d3d1',
      400: '#a8a29e',
      500: '#78716c',
      600: '#57534e',
      700: '#44403c',
      800: '#292524',
      900: '#1c1917',
      1000: '#141210',
      1100: '#0e0d0b',
      1200: '#090807',
      1300: '#050504',
      1400: '#030303',
      1500: '#020202',
    },
    trueGray: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#e5e5e5',
      300: '#d4d4d4',
      400: '#a3a3a3',
      500: '#737373',
      600: '#525252',
      700: '#404040',
      800: '#262626',
      850: '#1f1f1f',
      900: '#171717',
      1000: '#0f0f0f',
      1100: '#0a0a0a',
      1200: '#050505',
      1300: '#030303',
      1400: '#020202',
      1500: '#010101',
    },
    gray: {
      50: '#fafafa',
      100: '#f4f4f5',
      200: '#e4e4e7',
      300: '#d4d4d8',
      400: '#a1a1aa',
      500: '#71717a',
      600: '#52525b',
      700: '#3f3f46',
      800: '#27272a',
      850: '#202023',
      900: '#18181b',
      1000: '#111114',
      1100: '#0b0b0d',
      1200: '#060607',
      1300: '#030304',
      1400: '#020202',
      1500: '#010101',
    },
    coolGray: {
      50: '#f9fafb',
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827',
      1000: '#0c121d',
      1100: '#080d15',
      1200: '#05090f',
      1300: '#03060b',
      1400: '#020407',
      1500: '#010204',
    },
    blueGray: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
      1000: '#0b101f',
      1100: '#070b16',
      1200: '#05070f',
      1300: '#03050b',
      1400: '#020307',
      1500: '#010204',
    },
    dark: {
      50: '#18181b',
      100: '#27272a',
      200: '#3f3f46',
      300: '#52525b',
      400: '#71717a',
      500: '#a1a1aa',
      600: '#d4d4d8',
      700: '#e4e4e7',
      800: '#f4f4f5',
      900: '#fafafa',
      1000: '#ffffff',
      1100: '#ffffff',
      1200: '#ffffff',
      1300: '#ffffff',
      1400: '#ffffff',
      1500: '#ffffff',
    },
    text: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#e5e5e5',
      300: '#d4d4d4',
      400: '#a3a3a3',
      500: '#737373',
      600: '#525252',
      700: '#404040',
      800: '#262626',
      900: '#171717',
      1000: '#0f0f0f',
      1100: '#0a0a0a',
      1200: '#050505',
      1300: '#030303',
      1400: '#020202',
      1500: '#010101',
    },
    
    // Derived colors
    danger: {},
    error: {},
    success: {},
    warning: {},
    muted: {},
    primary: {},
    info: {},
    secondary: {},
    light: {
        50: '#f6f6f6',
        100: '#f0f0f0',
        200: '#e5e5e5',
        300: '#d4d4d4',
        400: '#a3a3a3',
        500: '#737373',
        600: '#525252',
        700: '#404040',
        800: '#262626',
        900: '#171717',
    },
    /*tertiary: {},*/
    
    theme: {
      
      light: {
        text: '#2e2e2e',
        background: '#fff',
      },

      dark: {
        text: '#FFFFFF',
        background: '#0f0f0f',
      }
    }
  };
  
colors.danger = colors.red;
colors.error = colors.red;
colors.success = colors.green;
colors.warning = colors.orange;
colors.muted = colors.trueGray;
colors.primary = colors.cyan;
colors.secondary = colors.pink;
colors.info = colors.bmwLightBlue;

export default colors;
  